/**
 * eComicシリーズ アプリケーションカラーパレット
 * src/styles/variables.css と同期
 */

export const COLORS = {
  // eComicシリーズ - メインカラー
  ecomicScreenPlus: "#00479D",
  ecomicSR: "#DF003A",
  ecomicScreenRem: "#009e9f",

  // eComicシリーズ - ライトカラー（背景用・ProductDetail用）
  ecomicScreenPlusLight: "rgb(180, 220, 255)",
  ecomicSRLight: "rgb(255, 160, 160)",
  ecomicScreenRemLight: "rgb(80, 180, 160)",

  // UI共通色
  // accentPrimary: "#006699",
  // accentSecondary: "#764ba2",

  // テキスト色
  // textPrimary: "#1a1a1a",
  // textSecondary: "#2d2d2d",
  // textLight: "#694e39",

  // 背景色
  // bgPrimary: "#ffffff",
  // bgSecondary: "#f8f9fa",
} as const;

// ショートハンド：ProductDetail の themeColor用
export const THEME_COLORS = {
  screenPlus: COLORS.ecomicScreenPlusLight,
  sr: COLORS.ecomicSRLight,
  screenRem: COLORS.ecomicScreenRemLight,
} as const;

export type ColorKey = keyof typeof COLORS;
export type ThemeColorKey = keyof typeof THEME_COLORS;
